import CommunicationHandler from '@pipltrust/pub-sub-client';
import LoggerService, { LoggingLevel } from '@pipltrust/logger-service';
import TokenManager from '@pipltrust/jwt-service';
import AxiosClient from '@pipltrust/axios-client';

const REFRESH_TOKEN_INTERVAL_MINUTES = 10;
const { BASE_URL } = window.__CONFIG__.BASE_URL;
const JWT_COOKIE_NAME = window.__CONFIG__.JWT_COOKIE_NAME;
const LOG_REFRESH_TOKEN_ENABLED = window.__CONFIG__.LOG_REFRESH_TOKEN_ENABLED;

const loggerService = new LoggerService({
  loggingEnabled: LOG_REFRESH_TOKEN_ENABLED,
  allowedLoggingLevel: LoggingLevel.INFO,
});
const tokenManager = new TokenManager({});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
}

export const initWorker = () => {
  const jwtToken = getCookie(JWT_COOKIE_NAME);

  // Only run the JWT-refresh worker when logged in. On unauthenticated pages
  // (e.g. the React login page) there is no JWT cookie, and starting the worker
  // would call refresh-token with no token -> "Missing jwt_token" and can trigger
  // a token-expire redirect that interrupts login.
  if (!jwtToken) {
    return null;
  }

  const url = new URL('../web_worker.worker.js', import.meta.url);
  const workerBlob = new Blob([`import "${url}"`], { type: 'text/javascript' });
  const blobUrl = window.URL.createObjectURL(workerBlob);
  const worker = new Worker(blobUrl, { type: 'module', name: 'test' });

  tokenManager.setToken(jwtToken);

  window.addEventListener('mousemove', () => {
    worker.postMessage({
      type: 'mousemove',
      category: 'event',
    });
  });

  window.addEventListener('keypress', () => {
    worker.postMessage({
      type: 'keypress',
      category: 'event',
    });
  });

  CommunicationHandler.onTokenExpire(() => {
    worker.postMessage({ type: 'tokenExpire', category: 'event' });
    tokenManager.deleteToken();
    tokenManager.deleteRefreshToken();
  });

  worker.postMessage({
    type: 'start',
    category: 'event',
    authClient: null,
    baseUrl: BASE_URL,
    refreshInterval: REFRESH_TOKEN_INTERVAL_MINUTES,
  });

  worker.onmessage = ({ data }) => {
    loggerService.info(data?.message);

    if (data?.message === 'token is not valid') {
      loggerService.info('using token expire');
      CommunicationHandler.emitTokenExpire();
      if (data.status == 302) {
        window.location.href = data.redirectUrl;
      }
    }

    if (data?.message === 'connection error') {
      loggerService.info('connection error');

      const client = new AxiosClient({ tokenManager });
      client.isTokenValid();
      CommunicationHandler.emitTokenExpire();

      return;
    }

    if (data?.message === 'refreshed token') {
      loggerService.info('setting new refresh token and jwt token');

      return;
    }

    if (data?.message === 'console log') {
      loggerService.info(data?.consoleMessage);
    }
  };
  return worker;
};
